export default __webpack_public_path__ + "static/media/teacher.aab5cac1.png";